import type { Route } from '@phi/vue-router';
import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import styles from '../../components/index.module.scss';
import { type PropType, defineComponent, h, ref } from 'vue';
import { Page } from '../../components/page';
import { Button, utility } from '@phi/components';
import { Text } from '@components/text';
import { FormText } from '@components/form';
import { Flex } from '@phi/components/layout';
import { LoginPage } from '../login-page';
import { EmailParser } from '@phi/parsing';
import { EmailSentPage } from '../email-sent-page';

export const ForgotPasswordPage = defineComponent({
    name: 'ForgotPasswordPage',

    props: {
        app: {
            required: true,
            type: Object as PropType<IFrontendServiceContainer>,
        },

        route: {
            required: true,
            type: Function as PropType<Route>,
        },
    },

    setup({ app, route }) {
        const auth = app.authentication;

        const email = ref('');

        function on_go_back() {
            route(() => h(LoginPage, { app, route }));
        }

        function on_email() {
            const parsed = EmailParser(email.value);
            if (parsed instanceof Error) return;
            auth.forgot_my_password(parsed)
                .then(x => {
                    if (x instanceof Error)
                        return; // todo error handling
                    else
                        route(() => h(EmailSentPage, { app }));
                });
        }

        return () => h(Page, { light: app.util.dark_mode_enabled() }, () => h('form', {
            class: utility.margin_gap_5,
            onSubmit: on_email,
        }, [
            h('header', [
                h(Text, { size: 'huge', class: styles.faded }, () => 'Recover password'),
            ]),

            h('fieldset', [
                h('label', 'Email address'),
                h(FormText, {
                    placeholder: 'your-email@example.com',
                    type: 'email',
                    value: email.value,
                    variant: 'outlined',
                    'onUpdate:value': x => email.value = x,
                    parser: EmailParser as any,
                }),
            ]),

            h(Flex, {
                direction: 'row',
            }, () => [
                h(Button, {
                    variant: 'outlined',
                    block: true,
                    class: styles.height,
                    onClick: on_go_back,
                }, () => 'Go back'),

                h(Button, {
                    variant: 'primary',
                    block: true,
                    class: styles.height,
                    onClick: on_email,
                }, () => 'Email me a recovery link'),
            ])
        ]));
    },
});
